module.exports = __webpack_public_path__ + "assets/img/working-lithuania-small.dedf50ac.jpg";